<template>
	<div>
		<Loading v-if="loading" />
		<Header />
		<TitlePage />

		<b-container fluid="lg">
			<div class="page-sub-title">
				<h1>{{ $t('packagesscreen.packageScreenTitle') }}</h1>
			</div>
			<div class="packages-div">
				<Packages
						
						@childToParent="getSelectedPackages"
						:userPayment="arrUserPayment"
						:website="website"
					/>
			</div>
			<div class="button-div">
				<b-button
					id="paymentNewPackage"
					@click="paymentNewPackage"
					class="btn-submit-search"
					v-if="!disabled"
					:disabled="disabled"
					>{{ $t('packagesscreen.buttontext') }}</b-button
				>
			</div>
		</b-container>
		<Footer />
	</div>
</template>
<script>
import Packages from '@/components/packages/Packages';
import Header from '@/components/ui/header';
import TitlePage from '@/components/ui/titlePage';
import Footer from '@/components/ui/footer';
import { mapGetters, mapActions, mapState } from 'vuex';
import Loading from '@/components/ui/loading';

export default {
	name: 'UserPackageScreen',
	components: { Packages, Header, TitlePage, Footer, Loading },
	data() {
		return {
			packageDetailIds: [],
			urlWebsite: null,
			loading: false,
			disabled: true,
			arrUserPayment : [],
			website: null,
			affiliate_dates_ids:''
		};
	},
	watch:{
		'packageDetailIds'(val){
			if(val.length){
				if(val.indexOf(10)>-1&&!this.urlWebsite){
					this.disabled=true;
				}else{
					this.disabled=false;
				}
			}else{
				this.disabled=true;
			}
		},
		urlWebsite(val){
			if (val.match('https://') || val.match('http://')) {
				this.disabled = false;
				return;
			} else {
				this.disabled = true;
			}
		}
	},
	methods: {
		...mapActions('PackageController', ['PAYMENT_NEW_PACKAGE']),
		
		getSelectedPackages(ev) {
			console.log("ev",ev)
			let objectID = JSON.parse(JSON.stringify(ev));
			let arr = [];
			Object.values(ev.packagesValue).forEach(pack => {
				if (pack.packagesDetails) {
					arr.push(pack.packagesDetails.id);
				}
			});
			this.packageDetailIds = arr;
			this.urlWebsite = objectID.websiteUrl;
			let datesArr = [];
			ev.preBookedDates.forEach(date => {
				datesArr.push(date.id);
			});
			this.affiliate_dates_ids = datesArr;
			this.$forceUpdate();
		},
		paymentNewPackage() {
			this.loading = true;
			let obj={
				id: this.$route.params.id,
				package_detail_ids: this.packageDetailIds,
			};
			if(this.website){
				obj.website=this.website;
			}
			if(this.affiliate_dates_ids){
				obj.affiliate_dates_ids=this.affiliate_dates_ids;
			}
			
			this.PAYMENT_NEW_PACKAGE(obj).then(result => {
				this.loading = false;
				this.$router.push(
					this.$i18nRoute({ name: 'payment' }) + result.data.data.id
				);
			});
		}
	}
};
</script>
<style lang="scss">
@import 'style.scss';
</style>
